import React from "react";
import DokumenPusat from "../../components/organism/DokumenPusat";

const PageDokumenPusat = () => {
  return (
    <>
      <DokumenPusat />
    </>
  );
};

export default PageDokumenPusat;
